"use client";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { X } from "lucide-react";
import Table from "./table-winner";

export default function DialogTableWinner({
  campaign,
  openTable,
  setOpenTable,
}: {
  campaign: any;
  openTable: boolean;
  setOpenTable: (open: boolean) => void;
}) {

  return (
    <Dialog open={openTable} onOpenChange={setOpenTable}>
      <DialogContent
        onInteractOutside={(event) => {
          event.preventDefault();
        }}
        showCloseButton={false}
        className="bg-white p-0 overflow-hidden border-none rounded-2xl lg:max-w-[1400px] w-[calc(100vw-20px)] sm:max-w-[calc(100vw-20px)]"
      >
        <VisuallyHidden>
          <DialogTitle>Hidden Title</DialogTitle>
        </VisuallyHidden>
        <div
          className={`h-[calc(100vh-40px)] max-h-[100vh] flex flex-col gap-4 text-center text-white p-4`}
        >
          <div
            onClick={() => setOpenTable(false)}
            className="cursor-pointer flex items-center justify-center bg-gray-200 rounded-full w-7 h-7 absolute top-4 right-4"
          >
            <X className="w-4 h-4 text-gray-500" />
          </div>
          <div className="text-4xl font-bold text-black">Danh sách trúng giải</div>
          {
            openTable && (
              <Table 
                headerBackground="#C60E17"
                rounds={campaign?.rounds}
                campaign={campaign}
              />
            )
          }
        </div>
      </DialogContent>
    </Dialog>
  );
}
